import type { EnvironmentConfig } from "./Config";

export const Config: EnvironmentConfig = {
  GOOGLE_MAPS_API_KEY: "AIzaSyDVWt9l8CPdoB7GwbaYOHUrxpXfvGoWWp8",
  GOOGLE_OAUTH_CLIENT_ID:
    "210926201801-nhgk77c6fvsvqn5ngonar3p0d37g0an4.apps.googleusercontent.com",
  ENABLE_SERVICE_WORKER: false,
  ENABLE_WEB_VITALS: true,
  DEBUG: true,
};
